import { legacyPlugins } from "/usr/src/app/node_modules/.bun/@unhead+vue@3.4.3+44f131003e898e23/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}